/**
 * Tài khoản khách dev đang dùng (chỉ khi chạy live với backend local, AUTH_MODE=dev).
 * 05/10: app chỉ đăng nhập được `VITE_DEV_USERNAME` (cus1), nên không thử được khách của chuyến
 * khác (G2: khách của drv2 là cus2). Lựa chọn lưu ở trình duyệt; không đọc được thì dùng mặc định.
 */
export const DEV_CUSTOMERS = ['cus1', 'cus2'] as const;
const KEY = 'greensm.customer.devUser';

export function readDevUser(): string | null {
  try {
    const value = globalThis.localStorage?.getItem(KEY) ?? null;
    return value && (DEV_CUSTOMERS as readonly string[]).includes(value) ? value : null;
  } catch {
    return null;
  }
}

export function writeDevUser(username: string): void {
  try {
    globalThis.localStorage?.setItem(KEY, username);
  } catch {
    // Trình duyệt chặn lưu trữ: vẫn dùng được trong phiên hiện tại qua biến dưới đây.
  }
  current = username;
}

let current: string | null = null;

/** Tài khoản dùng cho token `dev-<username>` và đăng nhập BFF, đọc tại thời điểm gọi. */
export function devUser(fallback: string | undefined): string {
  return current ?? readDevUser() ?? fallback ?? 'cus1';
}

/**
 * Token phiên của POST /auth/login (mật khẩu thật): dùng làm Bearer cho /api/v3 và SSE.
 * Lưu ở localStorage để tab mới vẫn dùng được; xoá khi đăng xuất.
 */
const SESSION_KEY = 'greensm.customer.session';
let session: string | null = null;

export function writeSessionToken(token: string): void {
  session = token;
  try { globalThis.localStorage?.setItem(SESSION_KEY, token); } catch { /* chỉ giữ trong phiên */ }
}

export function clearSessionToken(): void {
  session = null;
  try { globalThis.localStorage?.removeItem(SESSION_KEY); } catch { /* bỏ qua */ }
}

export function sessionToken(): string | null {
  if (session) return session;
  try { return globalThis.localStorage?.getItem(SESSION_KEY) ?? null; } catch { return null; }
}

/** Token v3: phiên đăng nhập thật nếu có; chưa đăng nhập (mock / dev) thì token dev `dev-<username>`. */
export function v3Token(username: string): string {
  return sessionToken() ?? `dev-${username}`;
}
